import * as types from './meeting-archive.types';
export const meetingsArchivesPageSelectors: types.IMeetingArchivesSelectors = {
  selectMeetingArchivesIds: (state) => state.page.meetingArchives.meetingArchivesIds,
  selectMeetingArchiveCurrentPage: (state) => state.page.meetingArchives.currentPage,
  selectMeetingArchiveTotalPages: (state) => state.page.meetingArchives.totalPages,
};
